/**
 * @fileoverview PUT handler for the "/engagement/edit_locations_apps" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementEditLocationsAppsCacheKeys } from "./constants";
import type { PutEngagementEditLocationsAppsProps, EngagementEditLocationsAppsResult } from "./types";

export const putEngagementEditLocationsApps = reactQueryMutationAdapter(
  engagementEditLocationsAppsCacheKeys,
  (props: PutEngagementEditLocationsAppsProps): Promise<EngagementEditLocationsAppsResult> => {
    return fetch("/engagement/edit_locations_apps", "PUT", props);
  }
);
